import type { RewardsRow, RewardWorkerOption, WorkerRewardsSnapshot } from './model';

export const fixtureRewardWorkers: RewardWorkerOption[] = [
  { id: '01', label: '정성진 · A0001 · 한결' },
  { id: '02', label: '우디(박진우) · A0104 · Engineering Division' },
  { id: '03', label: '김민서 · A0142 · Product Division' },
  { id: '04', label: '이수연 · A0188 · Design Team' },
  { id: '05', label: '한도윤 · A0203 · Business Division' },
  { id: '06', label: '강예린 · A0221 · People & Culture' },
  { id: '07', label: '장우진 · A0238 · Platform Engineering Team' },
];

export const fixtureRewards: RewardsRow[] = [
  { id: 'contract', kind: 'CONTRACT', descriptor: '정규직 근로계약', detail: '주 40시간', period: '2024-03-04', status: 'ACTIVE' },
  { id: 'compensation', kind: 'COMPENSATION', descriptor: '기본 연봉', detail: '권한 필요', period: '2026-01-01', status: 'ACTIVE' },
  { id: 'benefit', kind: 'BENEFIT', descriptor: '단체보험', detail: '가족 포함', period: '2026-01-01', status: 'ACTIVE' },
];

export const fixtureRewardsSnapshot: WorkerRewardsSnapshot = {
  contracts: [{ id: 'contract', contractType: '정규직 근로계약', contractStatus: 'ACTIVE', weeklyHours: '40', effectiveFrom: '2024-03-04' }],
  compensation: [{ id: 'compensation', compensationType: 'BASE_SALARY', currencyCode: 'KRW', payFrequency: 'ANNUAL', protected: true, effectiveFrom: '2026-01-01' }],
  benefitEnrollments: [{ id: 'benefit', benefitPlan: { descriptor: '단체보험' }, coverageLevel: '가족 포함', enrollmentStatus: 'ACTIVE', effectiveFrom: '2026-01-01' }],
};
